"use client";

import { useSitecore, type TextField } from "@sitecore-content-sdk/nextjs";
import { ICONS } from "../variables/icons";
import { getSvgIconValue } from "../utils/iconHelper";

interface IconProps {
  icon: ICONS | string;
  className?: string;
  onClick?: () => void;
  jssIconTextField?: TextField;
  title?: string;
}

const Icon = ({
  icon,
  className,
  onClick,
  jssIconTextField,
  title,
}: IconProps) => {
  const { page } = useSitecore();
  const isPageEditing = page?.mode?.isEditing;

  let positionAdjust = "";

  if (icon === ICONS.CHEVRON_LEFT) {
    positionAdjust = "right-[1px]";
  } else if (icon === ICONS.CHEVRON_RIGHT) {
    positionAdjust = "left-[1px]";
  }

  const isInteractive = !!onClick;

  return (
    <span
      {...(isInteractive && {
        role: "button",
        tabIndex: 0,
        onClick,
        onKeyDown: (e: React.KeyboardEvent<HTMLSpanElement>) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick?.();
          }
        },
      })}
      title={isPageEditing && jssIconTextField ? "Change icon" : title}
      dangerouslySetInnerHTML={{
        __html: getSvgIconValue(icon),
      }}
      className={`icon-component flex justify-center items-center max-h-12.5 relative ${positionAdjust} ${className ?? ""}`}
    />
  );
};

export default Icon;
